import React from 'react';
import { SwiperSlide } from 'swiper/react';
import styled from 'styled-components';

import { SliderWrapper } from '@/components/LandingWidgets';
import { useTypedSelector } from '@/store/store';
import { selectSinglePost } from '@/store/reducers/single-post';
import PostCard from '@/components/PostCard';

function PostsSlider() {
  const page = useTypedSelector(selectSinglePost);

  if (!page || !page.relatedPosts || page.relatedPosts.length === 0) {
    return null;
  }

  const isWithoutPagination = page.relatedPosts.length === 1;

  return (
    <Component>
      <SliderWrapper
        options={{
          spaceBetween: 30,
          withoutPagination: isWithoutPagination,
          withoutNavs: true,
        }}
      >
        {page.relatedPosts.map(({ url, title, image }, index) => (
          <SwiperSlide key={index}>
            <PostCard title={title ?? ''} url={url ?? ''} image={image} />
          </SwiperSlide>
        ))}
      </SliderWrapper>
    </Component>
  );
}

export default PostsSlider;

const Component = styled.div`
  margin-top: 20px;
`;
